import Vue from "vue";
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs)


